/**
 * Inicializar botones de Foxkit Back In Stock en las tarjetas de producto de colecciones
 */
(function() {
  'use strict';

  function initFoxkitBISButtons() {
    // Esperar a que Foxkit esté completamente cargado
    if (typeof FoxKitV2 === 'undefined' || typeof FoxKitModules === 'undefined') {
      setTimeout(initFoxkitBISButtons, 200);
      return;
    }

    // Buscar todos los botones de BIS en tarjetas de producto Y en quickview
    const productCards = document.querySelectorAll('.m-product-card, .m-product-quickview, product-info');

    productCards.forEach((card) => {
      const bisButton = card.querySelector('.foxkit-bis-button');
      const productForm = card.querySelector('product-form');

      if (!bisButton || !productForm) return;

      // Evitar inicializar múltiples veces
      if (bisButton.hasAttribute('data-foxkit-initialized')) {
        return;
      }

      const productId = productForm.getAttribute('data-product-id');
      let productHandle = productForm.getAttribute('data-product-handle');

      // Fallback: buscar handle desde la tarjeta principal
      if (!productHandle) {
        productHandle = card.getAttribute('data-product-handle');
      }

      const form = productForm.querySelector('form');

      if (!form) {
        return;
      }

      // Obtener variant ID del input
      const variantIdInput = form.querySelector('input[name="id"]');
      const variantId = variantIdInput ? variantIdInput.value : null;

      if (!productId || !productHandle || !variantId) {
        return;
      }

      bisButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // Simular que estamos en un contexto de producto para que Foxkit funcione
        // Guardamos los datos actuales
        const originalProduct = window.FoxKitSettings?.product;
        const originalProductId = window.FoxKitSettings?.productId;

        // Temporalmente establecemos el producto actual
        fetch(`/products/${productHandle}.js`)
          .then(response => response.json())
          .then(productData => {
            // Buscar la variante
            const currentVariant = productData.variants.find(v => v.id === Number(variantId));

            if (!currentVariant) {
              return;
            }

            // Actualizar FoxKitSettings temporalmente
            if (window.FoxKitSettings) {
              window.FoxKitSettings.product = productData;
              window.FoxKitSettings.product.selectedVariant = currentVariant;
              window.FoxKitSettings.productId = productData.id;
            }

            if (window.FoxKitV2?.BIS) {
              // Obtener la instancia de BIS de Foxkit
              const bisInstance = window.FoxKitV2.BIS;

              if (bisInstance && typeof bisInstance.openPopup === 'function') {
                bisInstance.productData = productData;
                bisInstance.currentVariant = currentVariant;
                bisInstance.productId = productData.id;
                bisInstance.openPopup();
              } else {
                openFoxkitBISPopup(productData, currentVariant);
              }
            } else {
              openFoxkitBISPopup(productData, currentVariant);
            }

            // Restaurar valores originales después de 1 segundo
            setTimeout(() => {
              if (window.FoxKitSettings) {
                window.FoxKitSettings.product = originalProduct;
                window.FoxKitSettings.productId = originalProductId;
              }
            }, 1000);
          })
          .catch(() => {});
      });

      bisButton.setAttribute('data-foxkit-initialized', 'true');
    });
  }
  
  // Función alternativa para abrir el popup de Foxkit
  function openFoxkitBISPopup(productData, currentVariant) {
    const settings = window.FoxKitPlugins?.BIS || {};
    const modal = new window.FoxKitModules.Modal('foxkit-bis');
    modal.setWidth('400px');
    
    const popupContent = createBISPopup({
      settings,
      productData,
      currentVariant,
      modal
    });
    
    modal.appendChild(popupContent);
    modal.open();
  }
  
  // Función para crear el contenido del popup usando la estructura de Foxkit
  function createBISPopup({ settings, productData, currentVariant, modal }) {
    const container = document.createElement('div');
    container.className = 'lg:foxkit-flex foxkit-bis-popup';
    
    // Textos en español (hardcodeados como fallback)
    const heading = settings?.bis_heading || 'Back in stock alert 📬';
    const desc = settings?.bis_desc || 'Introduce tu e-mail y te avisaremos cuando esté disponible.';
    const emailPlaceholder = settings?.bis_email || 'Correo electrónico ';
    const namePlaceholder = settings?.bis_name || 'Nombre';
    const signupText = settings?.bis_signup || 'Envíame un correo electrónico con noticias y ofertas.';
    const submitText = settings?.bis_submit || 'Recibir aviso';

    // Obtener imagen del producto - verificar múltiples fuentes
    let productImage = '';
    let aspectRatio = 1;
    
    if (currentVariant.featured_image) {
      productImage = currentVariant.featured_image.src;
      aspectRatio = currentVariant.featured_image.width / currentVariant.featured_image.height;
    } else if (productData.featured_image) {
      productImage = productData.featured_image;
    } else if (productData.images && productData.images.length > 0) {
      productImage = productData.images[0];
    } else if (productData.media && productData.media.length > 0) {
      productImage = productData.media[0].src;
    }

    // Formatear precio
    const formattedPrice = formatMoney(currentVariant.price);
    const variantTitle = productData.variants?.length > 1 ? `${currentVariant.title} - ` : '';
    
    // Estructura EXACTA del popup original de Foxkit (aunque el producto se oculta con CSS)
    container.innerHTML = `
      <div class="foxkit-bis-popup__product foxkit-flex lg:foxkit-block">
        <div class="relative">
          <div class="foxkit-bis-popup__product-img" style="--foxkit-aspect-ratio: ${aspectRatio};">
            <img class="foxkit-lazy-img " src="${productImage ? productImage + '&width=600' : ''}" loading="lazy" alt="${productData.title}" style="">
          </div>
          <span class="foxkit-hidden lg:foxkit-flex prod__tag--soldout">Agotado</span>
        </div>
        <div class="foxkit-bis-popup__product-info">
          <span class="foxkit-inline-flex lg:foxkit-hidden prod__tag--soldout-mobile">Agotado</span>
          <h3 class="foxkit-bis-popup__product-title font-medium">${productData.title}</h3>
          <p>${variantTitle}<span class="foxkit-bis-popup__product-price"><span class="priceRange">${formattedPrice}</span></span></p>
        </div>
      </div>
      <div class="foxkit-bis-popup__form">
        <h3 class="foxkit-bis-popup__form-heading font-medium">${heading}</h3>
        <p class="foxkit-bis-popup__form-text">${desc}
</p>
        <form id="foxkit-bis-form">
          <input type="email" class="foxkit-form-control" name="email" required="" placeholder="${emailPlaceholder}">
          <input type="text" class="foxkit-form-control" name="firstName" placeholder="${namePlaceholder}">
          <label class="foxkit-bis-popup__sign-up foxkit-flex foxkit-items-center cursor-pointer">
            <input type="checkbox" name="saveToApp" value="true" class="foxkit-checkbox">
            <span>${signupText}</span>
          </label>
          <input type="hidden" class="foxkit-hidden" name="syncWithShopify" value="true">
          <input type="hidden" class="foxkit-hidden" name="saveToSubscriptionList" value="true">
          <input type="hidden" class="foxkit-hidden" name="acceptsMarketing" value="true">
          <button type="submit" class="foxkit-button foxkit-button--primary foxkit-bis-popup__submit">
            <div class="foxkit-spinner ">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </div>
            <span>${submitText}</span>
          </button>
          <div class="foxkit-watermark ">Powered by <a href="https://apps.shopify.com/foxkit?utm_source=merchant_store&utm_medium=BackInStock&utm_campaign=brandmark" target="_blank">FoxKit: All-in-one Sales Boost</a></div>
        </form>
      </div>
    `;
    
    // Manejar el submit del formulario
    const form = container.querySelector('#foxkit-bis-form');
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const submitButton = form.querySelector('button[type="submit"]');
      const formData = new FormData(form);
      
      formData.set('title', productData.title);
      formData.set('product_id', productData.id);
      formData.set('product_handle', productData.handle);
      formData.set('product_image_url', currentVariant.featured_image?.src || productData.images?.[0]?.src || '');
      formData.set('variant_id', currentVariant.id);
      formData.set('variant_title', currentVariant.title);
      formData.set('platforms', settings.platforms || []);
      
      submitButton.classList.add('foxkit-spinner--loading');
      
      try {
        const appURL = window.FoxKitSettings?.foxKitBaseUrl ? `https://${window.FoxKitSettings.foxKitBaseUrl}` : '';
        const response = await fetch(`${appURL}/api/public/back-in-stock?shop=${window.Shopify.shop}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: new URLSearchParams(formData)
        });
        
        const result = await response.json();
        
        modal.close();
        
        // Mostrar notificación de éxito
        if (result.ok) {
          const successMessage = window.__i18n?.transPlugin?.({
            configs: settings,
            key: 'bis_thankyou'
          }) || 'Thank you! We\'ll send you an email when this product is available!';
          
          if (window.FoxKitModules?.Notification) {
            window.FoxKitModules.Notification.show({
              target: document.body,
              method: 'appendChild',
              type: 'success',
              message: successMessage,
              delay: 300
            });
          }
        }
        
      } catch (error) {
      } finally {
        submitButton.classList.remove('foxkit-spinner--loading');
      }
    });
    
    return container;
  }
  
  // Función auxiliar para formatear precio
  function formatMoney(cents) {
    const moneyFormat = window.FoxKitSettings?.moneyFormat || '<span class=priceRange>{{amount_with_comma_separator}}€</span>';
    const price = (cents / 100).toFixed(2).replace('.', ','); // Formato español con coma
    return moneyFormat
      .replace('{{amount_with_comma_separator}}', price)
      .replace('{{amount}}', price);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFoxkitBISButtons);
  } else {
    initFoxkitBISButtons();
  }

  // Re-inicializar después de actualizaciones AJAX (filtros, paginación, etc.)
  if (typeof window.MinimogEvents !== 'undefined') {
    window.MinimogEvents.subscribe('collection:updated', initFoxkitBISButtons);
  }

  // Detectar cuando se abre el quickview modal y reinicializar botones
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.classList?.contains('m-modal') ||
              node.classList?.contains('m-product-quickview') ||
              node.querySelector?.('.m-product-quickview') ||
              node.querySelector?.('.foxkit-bis-button')) {
            setTimeout(initFoxkitBISButtons, 300);
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

